import React from 'react';
import { ExternalLinkIcon } from 'lucide-react';
interface Vendor {
  name: string;
  description: string;
  url: string;
  image: string;
}
const vendors: Vendor[] = [{
  name: 'Pure Dev Creatives',
  description: 'Balloon decor, room decorations, and full event planning to bring your celebration to life.',
  url: 'https://puredevcreative.com/services-content',
  image: 'https://cdn.magicpatterns.com/uploads/wDJ7bSXa931LPbNsjBZ83F/pasted-image.png'
}];
export const PreferredVendorsPage = () => {
  return <div className="bg-white w-full min-h-screen" data-id="element-944">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20" data-id="element-945">
        {/* Page Title Section */}
        <div className="text-center mb-16" data-id="element-946">
          <h1 className="text-4xl md:text-5xl font-bold text-primary-500 leading-tight" data-id="element-947">
            Preferred Vendors
          </h1>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-948">
            We love working alongside these trusted partners to make your event
            unforgettable. Click any vendor below to learn more about their
            services.
          </p>
        </div>

        {/* Vendor Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-949">
          {vendors.map(vendor => <a key={vendor.name} href={vendor.url} target="_blank" rel="noopener noreferrer" className="group block bg-white rounded-3xl shadow-lg border border-gray-100 overflow-hidden transition-all hover:shadow-xl hover:-translate-y-1" data-id="element-950">
              <div className="bg-gray-50 flex items-center justify-center p-8" data-id="element-951">
                <img src={vendor.image} alt={`${vendor.name} logo`} className="w-44 h-44 object-contain transition-transform duration-300 group-hover:scale-105" data-id="element-952" />
              </div>
              <div className="p-6 text-center" data-id="element-953">
                <h2 className="text-xl font-bold text-gray-900 mb-2" data-id="element-954">
                  {vendor.name}
                </h2>
                <p className="text-sm text-gray-600 mb-4" data-id="element-955">
                  {vendor.description}
                </p>
                <span className="inline-flex items-center text-sm font-semibold text-secondary-600 group-hover:text-secondary-700" data-id="element-956">
                  Visit Vendor
                  <ExternalLinkIcon className="ml-1.5 h-4 w-4" data-id="element-957" />
                </span>
              </div>
            </a>)}
        </div>
      </div>
    </div>;
};